export interface VideoDimensions {
  width?: number | null;
  height?: number | null;
}

export function validVideoDimensions(video: VideoDimensions): video is { width: number; height: number } {
  return Number.isInteger(video.width) && Number.isInteger(video.height)
    && video.width! > 0 && video.height! > 0 && video.width! <= 65536 && video.height! <= 65536;
}

/** Bound tall frames without reserving a wide canvas; smaller previews may use a lower height budget. */
export function videoFrameStyle(video: VideoDimensions, viewportHeightPercent = 80): { aspectRatio: string; maxWidth?: string } {
  if (!validVideoDimensions(video)) return { aspectRatio: '16 / 9' };
  return {
    aspectRatio: `${video.width} / ${video.height}`,
    ...(video.height > video.width ? { maxWidth: `${Number((viewportHeightPercent * video.width / video.height).toFixed(4))}svh` } : {}),
  };
}

export function applyVideoFrameStyle(element: HTMLElement, video: VideoDimensions): void {
  const style = videoFrameStyle(video);
  element.style.aspectRatio = style.aspectRatio;
  element.style.maxWidth = style.maxWidth ?? '';
}

export function videoDimensionsMessage(data: unknown, videoId?: string): data is { type: 'dewe-stream:dimensions'; version: 1; videoId: string; width: number; height: number } {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return false;
  const message = data as Record<string, unknown>;
  return message.type === 'dewe-stream:dimensions' && message.version === 1
    && typeof message.videoId === 'string' && (!videoId || message.videoId === videoId)
    && validVideoDimensions({ width: message.width as number, height: message.height as number });
}
